import Api from "../Api/Api";

export const getBlockedEmails = () => Api.get("admin/blockedEmails");
export const createBlockedEmail = (payload) => Api.post("admin/blockedEmails", payload);
export const deleteBlockedEmail = (email) => Api.delete(`admin/blockedEmails?email=${encodeURIComponent(email)}`);
